export default __webpack_public_path__ + "static/media/intel7100.6ff6be97.jpg";